import { SortDirection } from 'fabscale-app/models/enums/sort-options';

export default function dataTableSortIsAsc(
  sortDirection: SortDirection
): boolean {
  return sortDirection === 'ASC';
}
